import React from "react";
import useInvitations from "../hooks/useInvitations";
import Box from "./Box";

const greetings = ["Howdy", "Greetings", "Hello", "Hiya"];
const greeting = greetings[Math.floor(Math.random() * greetings.length)];

export default function () {
  const { user } = useInvitations();
  const name = user ? user.name : "Stranger";
  return (
    <Box
      title={`${greeting}, ${name}!`}
      backgroundColor="papayawhip"
      borderColor="lightsalmon"
    >
      <p>
        I am asking my friends to help me commemorate 2020 with a collaborative
        poster!&nbsp;
        <a target="_blank" href="https://poster2019.frank.dev">
          <i>(Just like we did in 2019!)</i>
        </a>
      </p>
      <p>
        I think we can all agree that 2020 was <b>Not Neat</b>. That's why, as a
        gesture of forced optimism, the theme of this year's poster is&nbsp;
        <b>"Something Good About 2020"</b>. 🌟
      </p>
      <p>
        So for those of you with an invitation: please submit an image that
        shows something good about your year. I'm sure you can think of
        something. 🤩 🐐 🧶
      </p>
      <p style={{ textAlign: "right", fontStyle: "italic" }}>
        - Your Friend Frank
      </p>
    </Box>
  );
}
